import { GET_API, PATCH_API, POST_API } from "../../Functionalities/APIs";

const BASE = "/items/categories/umbrellas/";
const UNREACHABLE = "Could not reach the server. Try again.";

const replyOf = (result) => (result && result.data) || null;
const failure = (reply) => ({ error: (reply && (reply.Error || reply.Message)) || UNREACHABLE });
const formOf = (fields) => {
  const form = new FormData();
  Object.entries(fields).forEach(([name, value]) => form.append(name, value));
  return form;
};

export const fetchUmbrellas = async ({ review = false, search = "", page = 1 }) => {
  const reply = replyOf(await GET_API("", `review=${review}&search=${encodeURIComponent(search)}&page=${page}`, BASE));
  return reply && reply.Status ? { count: reply.count, results: reply.results } : failure(reply);
};

export const updateUmbrella = async (id, fields) => {
  const reply = replyOf(await PATCH_API(formOf(fields), "", `${BASE}${id}/`));
  return reply && reply.Status ? { ok: true, umbrella: reply.umbrella } : failure(reply);
};

export const mergeUmbrella = async (id, intoId) => {
  const reply = replyOf(await POST_API(formOf({ into_id: intoId }), "", `${BASE}${id}/merge/`));
  return reply && reply.Status ? { ok: true } : failure(reply);
};

export const previewLinks = async () => {
  const reply = replyOf(await GET_API("", "", `${BASE}link-preview/`));
  if (!reply || !reply.Status) return failure(reply);
  const { category_count, groups, folds } = reply;
  return { category_count, groups, folds };
};

export const applyLinks = async ({ fold = false }) => {
  const reply = replyOf(await POST_API(formOf({ fold }), "", `${BASE}link-apply/`));
  return reply && reply.Status ? { linked: reply.linked, moved: reply.moved } : failure(reply);
};
